import * as client_hooks from '../../../src/hooks.client.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63')
];

export const server_loads = [11,4];

export const dictionary = {
		"/(landing)": [50],
		"/(rgpd)/(uppercase)/CGU": [54,[10,11]],
		"/(rgpd)/(uppercase)/CGV": [55,[10,11]],
		"/(user-creation)/account-validation/[token]": [58,[12]],
		"/(d)/admin": [26,[4,6]],
		"/(d)/admin/interventions": [27,[4,6]],
		"/(d)/admin/pricing": [28,[4,6]],
		"/(d)/admin/stats": [29,[4,6]],
		"/(d)/admin/teams": [30,[4,6]],
		"/(d)/admin/users": [31,[4,6]],
		"/(d)/assistant": [32,[4]],
		"/a/[refId]": [61,[13]],
		"/(rgpd)/cgu": [56,[10]],
		"/(rgpd)/cgv": [57,[10]],
		"/(d)/chunks": [33,[4]],
		"/(d)/console": [34,[4]],
		"/(d)/contacts": [35,[4]],
		"/(d)/(settings)/credits": [~20,[4,5]],
		"/(user-creation)/email-sent": [59,[12]],
		"/(user-creation)/engagement/[key]": [60,[12]],
		"/(d)/entry-points": [36,[4]],
		"/(d)/entry-points/create": [38,[4]],
		"/(d)/entry-points/[refId]": [37,[4]],
		"/(landing)/en": [51],
		"/exposition": [62],
		"/(fixee-tests)/fixee-tests-2": [49,[9]],
		"/(fixee-tests)/fixee-tests": [48,[8]],
		"/(landing)/fr": [52],
		"/(d)/home": [39,[4]],
		"/(d)/interventions": [40,[4]],
		"/(d)/interventions/[refId]": [41,[7]],
		"/(d)/(settings)/invoices": [21,[4,5]],
		"/i/[refId]": [63,[14]],
		"/(d)/knowledge-base": [42,[4]],
		"/(auth)/login": [15,[2]],
		"/(d)/my-requests": [43,[4]],
		"/(landing)/pricing_old": [53],
		"/(d)/(settings)/pricing": [22,[4,5]],
		"/(d)/(settings)/pricing/credits": [23,[4,5]],
		"/(d)/(settings)/profile": [24,[4,5]],
		"/(auth)/register": [16,[2]],
		"/(d)/report-templates": [44,[4]],
		"/(auth)/request-reset-password": [17,[2]],
		"/(auth)/request-reset-password/email-sent": [18,[3]],
		"/(auth)/reset-password/[token]": [19,[2]],
		"/(d)/statistics": [45,[4]],
		"/(d)/subscription": [46,[4]],
		"/(d)/team-reports/[shortId]": [47,[4]],
		"/(d)/(settings)/teams/[id]": [25,[4,5]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';